<template>
  <UpdateIndicator
    :status="status"
    class="flex flex-col items-start justify-start gap-0"
    :class="{ 'opacity-50': !addOn.is_active && !isAvailable }"
  >
    <div class="flex items-center justify-start w-full gap-2">
      <p class="add-on-header text-fg-link-primary line-clamp-1 mr-auto shrink-[20]">
        {{ settingStore.currency(addOn.price) }} - {{ addOn.name }}
      </p>
      <ArrowReturnLeftIcon
        v-show="status === UPDATE_INDICATOR_STATUS.UPDATED"
        class="return-left-icon w-3 h-3 text-fg-secondary cursor-pointer"
        @click.stop="reset"
      />
      <component
        v-show="!isAvailable && status !== UPDATE_INDICATOR_STATUS.NEW"
        :is="addOn.is_active ? EyeIcon : EyeSlashIcon"
        class="eye-icon w-4 h-4 text-fg-secondary"
        @click.stop="handleAddOnVisibility"
      />
      <component
        v-show="isAvailable || status === UPDATE_INDICATOR_STATUS.NEW"
        :is="status === UPDATE_INDICATOR_STATUS.NEW ? MinusIcon : PlusIcon"
        class="plus-minus-icon w-4 h-4 text-fg-secondary"
      />
    </div>
    <p class="add-on-description line-clamp-1 text-sm text-fg-secondary">{{ addOn.description }}</p>
  </UpdateIndicator>
</template>

<script lang="ts" setup>
import * as _ from 'lodash-es'
import { toRefs } from 'vue'

import ArrowReturnLeftIcon from '@/assets/arrowReturnLeft.svg?component'
import EyeIcon from '@/assets/eye.svg?component'
import EyeSlashIcon from '@/assets/eyeSlash.svg?component'
import MinusIcon from '@/assets/minus.svg?component'
import PlusIcon from '@/assets/plus.svg?component'
import UpdateIndicator from '@/common/components/atoms/UpdateIndicator.vue'
import {
  UPDATE_INDICATOR_STATUS,
  UpdateIndicatorStatus,
} from '@/modules/performance/interfaces/PerformanceTableInterfaces'
import { useSettingStore } from '@/stores/setting'

import { AddOnRead, PerformanceAddOnRead } from '@generated/types'

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (e: 'update:addOn', initialValue: AddOnRead | PerformanceAddOnRead): void
}>()

const props = withDefaults(
  defineProps<{
    addOn: AddOnRead | PerformanceAddOnRead
    initialAddOn?: AddOnRead | PerformanceAddOnRead
    isAvailable?: boolean
    status?: UpdateIndicatorStatus
  }>(),
  {
    initialAddOn: undefined,
    isAvailable: false,
    status: UPDATE_INDICATOR_STATUS.NONE,
  },
)
const { addOn, initialAddOn } = toRefs(props)

const settingStore = useSettingStore()

function reset() {
  if (!initialAddOn.value) return
  emit('update:addOn', _.cloneDeep(initialAddOn.value))
}
function handleAddOnVisibility() {
  emit('update:addOn', _.cloneDeep({ ...addOn.value, is_active: !addOn.value.is_active }))
}
</script>
